import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { interceptorService } from "@/app/core/interceptorService";

type Agent = any;

type AgentsState = {
  agents: Agent[];
  agentsLoaded: boolean;
  agentSlug: string;
  selectedAgent: Agent | null;
};

const initialState: AgentsState = {
  agents: [],
  agentsLoaded: false,
  agentSlug: "",
  selectedAgent: null,
};

const agentsSlice = createSlice({
  name: "agents",
  initialState,
  reducers: {
    setAgentSlug(state, action: PayloadAction<string>) {
      state.agentSlug = action.payload;
    },
    setSelectedAgent(state, action: PayloadAction<Agent | null>) {
      state.selectedAgent = action.payload;
    },
    setAgents(state, action: PayloadAction<Agent[]>) {
      state.agents = action.payload;
      state.agentsLoaded = true;
    },
  },
});

export const { setAgentSlug, setSelectedAgent, setAgents } = agentsSlice.actions;
export default agentsSlice.reducer;

export const fetchAgentsOnce = () => async (dispatch, getState) => {
  const { agentsLoaded } = getState().agents;
  if (agentsLoaded) return;

  const data = await interceptorService.getAgents();
  dispatch(setAgents(data.agents));
};
